import React from "react";

type SafeMarkdownProps = { content: string };

export function SafeMarkdown({ content }: SafeMarkdownProps): JSX.Element {
  const lines = content.replace(/\r/g, "").split("\n");
  const blocks: React.ReactNode[] = [];
  let paragraph: string[] = [];
  let list: { ordered: boolean; items: string[] } | null = null;

  function flushParagraph(): void {
    if (paragraph.length > 0) {
      blocks.push(<p key={`p-${blocks.length}`}>{paragraph.join(" ")}</p>);
      paragraph = [];
    }
  }

  function flushList(): void {
    if (!list) return;
    const items = list.items.map((item, index) => <li key={`${index}-${item}`}>{item}</li>);
    blocks.push(list.ordered
      ? <ol key={`ol-${blocks.length}`}>{items}</ol>
      : <ul key={`ul-${blocks.length}`}>{items}</ul>);
    list = null;
  }

  for (const rawLine of lines) {
    const line = rawLine.trim();
    const heading = /^(#{1,4})\s+(.+)$/.exec(line);
    const unordered = /^[-*]\s+(.+)$/.exec(line);
    const ordered = /^\d+[.)]\s+(.+)$/.exec(line);
    if (heading) {
      flushParagraph();
      flushList();
      const level = Math.min(heading[1].length + 1, 5);
      blocks.push(React.createElement(`h${level}`, { key: `h-${blocks.length}` }, heading[2]));
    } else if (unordered || ordered) {
      flushParagraph();
      const isOrdered = Boolean(ordered);
      if (list && list.ordered !== isOrdered) flushList();
      list = list ?? { ordered: isOrdered, items: [] };
      list.items.push((unordered || ordered)?.[1] ?? line);
    } else if (line.startsWith("> ")) {
      flushParagraph();
      flushList();
      blocks.push(<blockquote key={`q-${blocks.length}`}>{line.slice(2)}</blockquote>);
    } else if (/^(-{3,}|\*{3,})$/.test(line)) {
      flushParagraph();
      flushList();
      blocks.push(<hr key={`hr-${blocks.length}`} />);
    } else if (line === "") {
      flushParagraph();
      flushList();
    } else {
      flushList();
      paragraph.push(line);
    }
  }
  flushParagraph();
  flushList();

  return <div className="private-news-markdown">{blocks}</div>;
}
